<!-- 限销商品操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box" v-if="scope.index == 0">
                                <!-- 主要信息 -->
                                <el-form label-width="160px" label-position="right" size="mini" class="baseForm"
                                    :model="sendDataInfo" ref="sendDataInfo">
                                    <el-row>
                                        <el-form-item label="商品预警阈值 "
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="goodsNum">
                                            <label slot="label" :style="$common.labelStyle('商品预警阈值 ')"
                                                v-html="$common.htmlLabel('商品预警阈值 ')"></label>
                                            <el-input class="form_codition" type="number"
                                                v-model.trim="sendDataInfo.goodsNum" :maxlength="$store.state.inputLength"
                                                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                        </el-form-item>
                                          <el-form-item label="供货商证照预警阈值"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="supplierNum">
                                            <label slot="label" :style="$common.labelStyle('供货商证照预警阈值')"
                                                v-html="$common.htmlLabel('供货商证照预警阈值')"></label>
                                            <el-input class="form_codition" type="number"
                                                v-model.trim="sendDataInfo.supplierNum"
                                                :maxlength="$store.state.inputLength"
                                                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                        </el-form-item>
                                        <el-form-item label="客户证照预警阈值"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="customerNum">
                                            <label slot="label" :style="$common.labelStyle('客户证照预警阈值')"
                                                v-html="$common.htmlLabel('客户证照预警阈值')"></label>
                                            <el-input class="form_codition" type="number"
                                                v-model.trim="sendDataInfo.customerNum"
                                                :maxlength="$store.state.inputLength"
                                                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                        </el-form-item>
                                      <el-form-item label="委托书预警阈值"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="salesNum">
                                            <label slot="label" :style="$common.labelStyle('委托书预警阈值')"
                                                v-html="$common.htmlLabel('委托书预警阈值')"></label>
                                            <el-input class="form_codition" type="number"
                                                v-model.trim="sendDataInfo.salesNum" :maxlength="$store.state.inputLength"
                                                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                        </el-form-item>
                                        <el-form-item label="回执时间阈值"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="receiptNum">
                                            <label slot="label" :style="$common.labelStyle('回执时间阈值')"
                                                v-html="$common.htmlLabel('回执时间阈值')"></label>
                                            <el-input class="form_codition" type="number"
                                                v-model.trim="sendDataInfo.receiptNum" :maxlength="$store.state.inputLength"
                                                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                        </el-form-item>
                                            <el-form-item label="近效期预警1"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="expiNum1">
                                            <label slot="label" :style="$common.labelStyle('近效期预警1')"
                                                v-html="$common.htmlLabel('近效期预警1')"></label>
                                            <el-input class="form_codition" type="number"
                                                v-model.trim="sendDataInfo.expiNum1" :maxlength="$store.state.inputLength"
                                                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                        </el-form-item>
                                             <el-form-item label="近效期预警2"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="expiNum2">
                                            <label slot="label" :style="$common.labelStyle('近效期预警2')"
                                                v-html="$common.htmlLabel('近效期预警2')"></label>
                                            <el-input class="form_codition" type="number"
                                                v-model.trim="sendDataInfo.expiNum2" :maxlength="$store.state.inputLength"
                                                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                        </el-form-item>
                                            <el-form-item label="近效期预警3"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]" prop="expiNum3">
                                            <label slot="label" :style="$common.labelStyle('近效期预警3')"
                                                v-html="$common.htmlLabel('近效期预警3')"></label>
                                            <el-input class="form_codition" type="number"
                                                v-model.trim="sendDataInfo.expiNum3" :maxlength="$store.state.inputLength"
                                                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>

                <div style="text-align:center; margin-top: 20px;">
                    <el-button v-if="dataActionBox.actionType != 2" type="primary"
                        @click="$emit('drawerCancel')">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                        v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                        v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
    name: "licenseWarnDataAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            mxHeight: 0,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            parentSearchData: {},
            seId: 0,
            cmId: 0,
            selectedDataIndex: 0,
            sendDataInfo: {
                customerNum: '', //	客户证照预警阈值
                goodsNum: '', //	商品证照阈值
                receiptNum: '', //	回执时间阈值
                salesNum: '', //对方业务员证照阈值
                supplierNum: '', //	供货商证照预警阈值
                warId: '', //	ID
                expiNum1: '', //	近效期预警1
                expiNum2: '', //	近效期预警2
                expiNum3: '', //	近效期预警3
            },
            goodsData: [],
            addForm: {
                glcId: ''
            },
            tabForm: [],
            showTabs: "",
            DialogVisible: false, //检索
            seId: "",
            seWidth: "",
            seTitle: "",
            seType: "",
            isLoaded: false,
            options: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
        },
        delGoods() {
            if (this.goodsData.length > 0) {
                this.goodsData.splice(this.selectedDataIndex, 1)
            } else {
                this.$message.error('暂无可删除的数据')
            }
        },
        //提取返回
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.goodsData.findIndex(item => item.bgmId == val.bgmId) == -1) {
                    this.goodsData.push(val)
                }
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },

        //确认新增
        sendDataAction(formName1) {
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    // console.log('sendDataInfo', this.sendDataInfo)
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        searchDataList() {
            this.$http.queryClassifyData({ classifyName: '' }).then(res => {
                if (res.status == 200) {
                    this.options = res.result
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        async sub() {
            var responseData;
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.licenseWarnUpdateLicenseWarn(this.sendDataInfo);
            } else if (this.dataActionBox.actionType == 1) {
                responseData = await this.$http.licenseWarnUpdateLicenseWarn(this.sendDataInfo);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel");
                // this.dataActionBox.showStatus = false
                // this.$parent.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        //取消
        initActionBox(formName1) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
            this.$confirm("确定取消修改配置吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel");
                    // this.$parent.getDataList()
                    this.init();
                    this.$refs[formName1].resetFields();
                })
                .catch(() => { });
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "scopeType") {
                    this.sendDataInfo[key] = 0;
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
        },
        //父级传入
        openBox(cate, formData, oldData = "") {
            this.filterMainField()
            this.init();
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增";
                this.dataActionBox.openMode = "ltr";
            } else if (cate == 1) {
                this.dataActionBox.boxTitle = "编辑";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
            } else {
                this.dataActionBox.boxTitle = "查看";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
            }
            this.dataActionBox.actionType = cate;
            console.log(this.dataActionBox.actionType, cate);
            this.dataActionBox.showStatus = true;
            this.showTabs = this.dataActionBox.boxTitle + '配置'
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 16.7)
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            this.tabForm = [
                {
                    // jciName: this.dataActionBox.boxTitle + '修改配置',
                    jciName: '修改配置',
                    jurconfigform: []
                }
            ]
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.$nextTick(() => {
        this.searchDataList()

        var params = this.actionData;
        console.log(params);
        this.openBox(params.cate, params.formData, params.oldData);
        this.isLoaded = true;
        // });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}
</style>
